
export class ConsumoSMSFileDTO{

    [key : string] : string;
    

}
